module.exports = __webpack_public_path__ + "static/img/rectangle03.46f8e46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/rectangle/rectangle03.jpg
// module id = KACw
// module chunks = 0